import { getState } from '~src/state';
import { exportIMG } from '~core';
import { b64toBlob } from '~core';

export default async function exportProjectToURL(exportSettings = {}) {
  const project = getState('selected.tipo');

  const projectExport = exportIMG(
    exportSettings.quality || 1,
    exportSettings.outputDpi || project.outputDpi,
    exportSettings.format || 'base64',
    exportSettings.imageFormat || 'jpeg',
    exportSettings.cleanBase64String || true,
    exportSettings.multiplier || 1
  );

  const ephemeralUploader = getState('uploader.ephemeral');
  const blob = b64toBlob(projectExport.base64, projectExport.contentType);

  ephemeralUploader.addFile({
    type: blob.type,
    data: blob,
  });

  const responseUpload = await ephemeralUploader.upload();

  ephemeralUploader.cancelAll();

  const imageUrl = `${process.env.EDGE_RESIZER}${
    new URL(responseUpload.successful[0].uploadURL).pathname
  }`;

  return imageUrl;
}
